(window.slate = window.slate || {}), (window.theme = window.theme || {});
var _createClass = (function () {
    function t(t, e) {
        for (var n = 0; n < e.length; n++) {
            var i = e[n];
            (i.enumerable = i.enumerable || !1),
                (i.configurable = !0),
                "value" in i && (i.writable = !0),
                Object.defineProperty(t, i.key, i);
        }
    }
    return function (e, n, i) {
        return n && t(e.prototype, n), i && t(e, i), e;
    };
})();
function _classCallCheck(t, e) {
    if (!(t instanceof e)) throw TypeError("Cannot call a class as a function");
}
(slate.a11y = {
    pageLinkFocus: function (t) {
        var e = "js-focus-hidden";
        t.first()
            .attr("tabIndex", "-1")
            .focus()
            .addClass(e)
            .one("blur", function n() {
                t.first().removeClass(e).removeAttr("tabindex");
            });
    },
    focusHash: function () {
        var t = window.location.hash;
        t && document.getElementById(t.slice(1)) && this.pageLinkFocus($(t));
    },
    bindInPageLinks: function () {
        $("a[href*=#]").on(
            "click",
            function (t) {
                this.pageLinkFocus($(t.currentTarget.hash));
            }.bind(this),
        );
    },
    trapFocus: function (t) {
        var e = t.namespace ? "focusin." + t.namespace : "focusin";
        t.$elementToFocus || (t.$elementToFocus = t.$container),
            t.$container.attr("tabindex", "-1"),
            t.$elementToFocus.focus(),
            $(document).on(e, function (e) {
                t.$container[0] === e.target ||
                    t.$container.has(e.target).length ||
                    t.$container.focus();
            });
    },
    removeTrapFocus: function (t) {
        var e = t.namespace ? "focusin." + t.namespace : "focusin";
        t.$container &&
            t.$container.length &&
            t.$container.removeAttr("tabindex"),
            $(document).off(e);
    },
}),
    (slate.cart = {
        cookiesEnabled: function () {
            var t = navigator.cookieEnabled;
            return (
                t ||
                ((document.cookie = "testcookie"),
                    (t = -1 !== document.cookie.indexOf("testcookie"))),
                t
            );
        },
    }),
    (slate.utils = {
        findInstance: function (t, e, n) {
            for (var i = 0; i < t.length; i++) if (t[i][e] === n) return t[i];
        },
        removeInstance: function (t, e, n) {
            for (var i = t.length; i--;)
                if (t[i][e] === n) {
                    t.splice(i, 1);
                    break;
                }
            return t;
        },
        compact: function (t) {
            for (
                var e = -1, n = null == t ? 0 : t.length, i = 0, a = [];
                ++e < n;

            ) {
                var s = t[e];
                s && (a[i++] = s);
            }
            return a;
        },
        defaultTo: function (t, e) {
            return null == t || t != t ? e : t;
        },
    }),
    (slate.rte = {
        wrapTable: function (t) {
            var e = void 0 === t.tableWrapperClass ? "" : t.tableWrapperClass;
            t.$tables.wrap('<div class="' + e + '"></div>');
        },
        wrapIframe: function (t) {
            var e = void 0 === t.iframeWrapperClass ? "" : t.iframeWrapperClass;
            t.$iframes.each(function () {
                $(this).wrap('<div class="' + e + '"></div>'),
                    (this.src = this.src);
            });
        },
    }),
    (slate.Sections = function t() {
        (this.constructors = {}),
            (this.instances = []),
            $(document)
                .on("shopify:section:load", this._onSectionLoad.bind(this))
                .on("shopify:section:unload", this._onSectionUnload.bind(this))
                .on("shopify:section:select", this._onSelect.bind(this))
                .on("shopify:section:deselect", this._onDeselect.bind(this))
                .on("shopify:section:reorder", this._onReorder.bind(this))
                .on("shopify:block:select", this._onBlockSelect.bind(this))
                .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
    }),
    (slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
        _createInstance: function (t, e) {
            var n = $(t),
                i = n.attr("data-section-id"),
                a = n.attr("data-section-type");
            if (void 0 !== (e = e || this.constructors[a])) {
                var s = $.extend(new e(t), { id: i, type: a, container: t });
                this.instances.push(s);
            }
        },
        _onSectionLoad: function (t) {
            var e = $("[data-section-id]", t.target)[0];
            e && this._createInstance(e);
        },
        _onSectionUnload: function (t) {
            var e = slate.utils.findInstance(
                this.instances,
                "id",
                t.detail.sectionId,
            );
            e &&
                ("function" == typeof e.onUnload && e.onUnload(t),
                    (this.instances = slate.utils.removeInstance(
                        this.instances,
                        "id",
                        t.detail.sectionId,
                    )));
        },
        _onSelect: function (t) {
            var e = slate.utils.findInstance(
                this.instances,
                "id",
                t.detail.sectionId,
            );
            e && "function" == typeof e.onSelect && e.onSelect(t);
        },
        _onDeselect: function (t) {
            var e = slate.utils.findInstance(
                this.instances,
                "id",
                t.detail.sectionId,
            );
            e && "function" == typeof e.onDeselect && e.onDeselect(t);
        },
        _onReorder: function (t) {
            var e = slate.utils.findInstance(
                this.instances,
                "id",
                t.detail.sectionId,
            );
            e && "function" == typeof e.onReorder && e.onReorder(t);
        },
        _onBlockSelect: function (t) {
            var e = slate.utils.findInstance(
                this.instances,
                "id",
                t.detail.sectionId,
            );
            e && "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        },
        _onBlockDeselect: function (t) {
            var e = slate.utils.findInstance(
                this.instances,
                "id",
                t.detail.sectionId,
            );
            e && "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
        },
        register: function (t, e) {
            (this.constructors[t] = e),
                $("[data-section-type=" + t + "]").each(
                    function (t, n) {
                        this._createInstance(n, e);
                    }.bind(this),
                );
        },
    })),
    (slate.Currency = {
        formatMoney: function t(e, n) {
            "string" == typeof e && (e = e.replace(".", ""));
            var i = "",
                a = /\{\{\s*(\w+)\s*\}\}/,
                s = n || "${{amount}}";
            function o(t, e, n, i) {
                if (
                    ((e = slate.utils.defaultTo(e, 2)),
                        (n = slate.utils.defaultTo(n, ",")),
                        (i = slate.utils.defaultTo(i, ".")),
                        isNaN(t) || null == t)
                )
                    return 0;
                var a,
                    s = (t = (t / 100).toFixed(e)).split(".");
                return (
                    s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n) +
                    (s[1] ? i + s[1] : "")
                );
            }
            switch (s.match(a)[1]) {
                case "amount":
                    i = o(e, 2);
                    break;
                case "amount_no_decimals":
                    i = o(e, 0);
                    break;
                case "amount_with_comma_separator":
                    i = o(e, 2, ".", ",");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    i = o(e, 0, ".", ",");
            }
            return s.replace(a, i);
        },
    }),
    (slate.Image = {
        preload: function t(e, n) {
            "string" == typeof e && (e = [e]);
            for (var i = 0; i < e.length; i++) {
                var a = e[i];
                this.loadImage(this.getSizedImageUrl(a, n));
            }
        },
        loadImage: function t(e) {
            new Image().src = e;
        },
        imageSize: function t(e) {
            var n = e.match(
                /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/,
            );
            return n ? n[1] : null;
        },
        getSizedImageUrl: function t(e, n) {
            if (null === n) return e;
            if ("master" === n) return this.removeProtocol(e);
            var i = e.match(
                /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i,
            );
            if (!i) return null;
            var a = e.split(i[0]),
                s = i[0];
            return this.removeProtocol(a[0] + "_" + n + s);
        },
        removeProtocol: function t(e) {
            return e.replace(/http(s)?:/, "");
        },
    }),
    (slate.Variants = (function () {
        function t(t) {
            (this.$container = t.$container),
                (this.product = t.product),
                (this.singleOptionSelector = t.singleOptionSelector),
                (this.originalSelectorId = t.originalSelectorId),
                (this.enableHistoryState = t.enableHistoryState),
                (this.currentVariant = this._getVariantFromOptions()),
                $(this.singleOptionSelector, this.$container).on(
                    "change",
                    this._onSelectChange.bind(this),
                );
        }
        return (
            (t.prototype = $.extend({}, t.prototype, {
                _getCurrentOptions: function () {
                    var t = $.map(
                        $(this.singleOptionSelector, this.$container),
                        function (t) {
                            var e = $(t),
                                n = e.attr("type"),
                                i = {};
                            return "radio" !== n && "checkbox" !== n
                                ? ((i.value = e.val()),
                                    (i.index = e.data("index")),
                                    i)
                                : !!e[0].checked &&
                                ((i.value = e.val()),
                                    (i.index = e.data("index")),
                                    i);
                        },
                    );
                    return slate.utils.compact(t);
                },
                _getVariantFromOptions: function () {
                    var t = this._getCurrentOptions(),
                        e = this.product.variants,
                        n = !1;
                    return (
                        e.forEach(function (e) {
                            var i = !0;
                            t.forEach(function (t) {
                                i && (i = t.value === e[t.index]);
                            }),
                                i && (n = e);
                        }),
                        n || null
                    );
                },
                _onSelectChange: function () {
                    var t = this._getVariantFromOptions();
                    this.$container.trigger({
                        type: "variantChange",
                        variant: t,
                    }),
                        t &&
                        (this._updateMasterSelect(t),
                            this._updateImages(t),
                            this._updatePrice(t),
                            (this.currentVariant = t),
                            this.enableHistoryState &&
                            this._updateHistoryState(t));
                },
                _updateImages: function (t) {
                    var e = t.featured_image || {},
                        n = this.currentVariant.featured_image || {};
                    t.featured_image &&
                        e.src !== n.src &&
                        this.$container.trigger({
                            type: "variantImageChange",
                            variant: t,
                        });
                },
                _updatePrice: function (t) {
                    (t.price !== this.currentVariant.price ||
                        t.compare_at_price !==
                        this.currentVariant.compare_at_price) &&
                        this.$container.trigger({
                            type: "variantPriceChange",
                            variant: t,
                        });
                },
                _updateHistoryState: function (t) {
                    if (history.replaceState && t) {
                        var e =
                            window.location.protocol +
                            "//" +
                            window.location.host +
                            window.location.pathname +
                            "?variant=" +
                            t.id;
                        window.history.replaceState({ path: e }, "", e);
                    }
                },
                _updateMasterSelect: function (t) {
                    $(this.originalSelectorId, this.$container)[0].value = t.id;
                },
            })),
            t
        );
    })()),
    (theme.Responsive = (function () {
        function t() {
            _classCallCheck(this, t),
                (this.currentBreakpoint = t.getCurrentBreakpoint()),
                window.addEventListener("resize", function () {
                    var e = t.getCurrentBreakpoint();
                    this.currentBreakpoint !== e &&
                        (document.dispatchEvent(
                            new CustomEvent("breakpoint:changed", {
                                detail: {
                                    previousBreakpoint: this.currentBreakpoint,
                                    currentBreakpoint: e,
                                },
                            }),
                        ),
                            (this.currentBreakpoint = e));
                });
        }
        return (
            (t.prototype.matchesBreakpoint = function (t) {
                switch (t) {
                    case "small":
                        return window.matchMedia(
                            "screen and (max-width: 640px)",
                        ).matches;
                    case "medium":
                        return window.matchMedia(
                            "screen and (min-width: 641px) and (max-width: 1007px)",
                        ).matches;
                    case "medium-up":
                        return window.matchMedia(
                            "screen and (min-width: 641px)",
                        ).matches;
                    case "medium-down":
                        return window.matchMedia(
                            "screen and (max-width: 1007px)",
                        ).matches;
                    case "large":
                        return window.matchMedia(
                            "screen and (min-width: 1008px) and (max-width: 1279px)",
                        ).matches;
                    case "large-up":
                        return window.matchMedia(
                            "screen and (min-width: 1008px)",
                        ).matches;
                    case "desktop":
                        return window.matchMedia(
                            "screen and (min-width: 1280px)",
                        ).matches;
                    case "widescreen":
                        return window.matchMedia(
                            "screen and (min-width: 1600px)",
                        ).matches;
                }
            }),
            (t.prototype.getCurrentBreakpoint = function () {
                return window.matchMedia("screen and (max-width: 640px)")
                    .matches
                    ? "small"
                    : window.matchMedia(
                        "screen and (min-width: 641px) and (max-width: 1007px)",
                    ).matches
                        ? "medium"
                        : window.matchMedia(
                            "screen and (min-width: 1008px) and (max-width: 1279px)",
                        ).matches
                            ? "large"
                            : window.matchMedia("screen and (min-width: 1280px)")
                                .matches
                                ? "desktop"
                                : void 0;
            }),
            t
        );
    })()),
    (theme.Carousels = (function () {
        function t(e) {
            var n =
                arguments.length > 1 && void 0 !== arguments[1]
                    ? arguments[1]
                    : {};
            _classCallCheck(this, t),
                (this.element = e),
                (this.initialConfig = $(e).data("flickity-config")),
                (this.options = n),
                this._attachListeners(),
                this._build();
        }
        return (
            (t.prototype.destroy = function () {
                this.flickityInstance.destroy(),
                    void 0 !== this.initialConfig.breakpoints &&
                    document.removeEventListener(
                        "breakpoint:changed",
                        this._onBreakpointChangedListener,
                    );
            }),
            (t.prototype.selectCell = function (t) {
                var e =
                    arguments.length > 1 &&
                    void 0 !== arguments[1] &&
                    arguments[1],
                    n =
                        !(arguments.length > 2) ||
                        void 0 === arguments[2] ||
                        arguments[2];
                e && this.flickityInstance.pausePlayer(),
                    this.flickityInstance.select(t, !1, !n);
            }),
            (t.prototype.pausePlayer = function () {
                this.flickityInstance.pausePlayer();
            }),
            (t.prototype.unpausePlayer = function () {
                this.flickityInstance.unpausePlayer();
            }),
            (t.prototype.resize = function () {
                this.flickityInstance.resize();
            }),
            (t.prototype.getSelectedIndex = function () {
                return this.flickityInstance.selectedIndex;
            }),
            (t.prototype.getSelectedCell = function () {
                return this.flickityInstance.selectedCell.element;
            }),
            (t.prototype._attachListeners = function () {
                void 0 !== this.initialConfig.breakpoints &&
                    ((this._onBreakpointChangedListener =
                        this._onBreakpointChanged.bind(this)),
                        document.addEventListener(
                            "breakpoint:changed",
                            this._onBreakpointChangedListener,
                        ));
            }),
            (t.prototype._build = function () {
                var t = this,
                    e = this._processConfig();
                (this.flickityInstance = new Flickity(this.element, e)),
                    this._validateDraggable(),
                    (this.selectedIndex = this.flickityInstance.selectedIndex),
                    this.flickityInstance.on(
                        "resize",
                        this._validateDraggable.bind(this),
                    ),
                    this.options.onSelect &&
                    this.flickityInstance.on("select", function () {
                        t.selectedIndex !==
                            t.flickityInstance.selectedIndex &&
                            (t.options.onSelect(
                                t.flickityInstance.selectedIndex,
                                t.flickityInstance.selectedCell.element,
                            ),
                                (t.selectedIndex =
                                    t.flickityInstance.selectedIndex));
                    }),
                    this.options.onClick &&
                    this.flickityInstance.on(
                        "staticClick",
                        function (e, n, i, a) {
                            t.options.onClick(i, a);
                        },
                    );
            }),
            (t.prototype._validateDraggable = function () {
                this.flickityInstance.isActive &&
                    this.flickityInstance.options.draggable &&
                    (void 0 === this.flickityInstance.selectedElements ||
                        this.flickityInstance.selectedElements.length ===
                        this.flickityInstance.cells.length
                        ? this.flickityInstance.unbindDrag()
                        : this.flickityInstance.bindDrag());
            }),
            (t.prototype._processConfig = function () {
                var t = Object.assign({}, this.initialConfig);
                return (delete t.breakpoints,
                    void 0 === this.initialConfig.breakpoints)
                    ? t
                    : (this.initialConfig.breakpoints.forEach(function (e) {
                        theme.Responsive.matchesBreakpoint(e.matches) &&
                            (t = Object.assign(t, e.settings));
                    }),
                        t);
            }),
            (t.prototype._onBreakpointChanged = function () {
                this.flickityInstance.destroy(), this._build();
            }),
            t
        );
    })()),
    (theme.Modals = (function () {
        function t(t, e, n) {
            if (
                ((this.id = t), (this.$modal = $("#" + t)), !this.$modal.length)
            )
                return !1;
            (this.nodes = {
                $parent: $("html").add("body"),
                $modalContent: this.$modal.find(".modal__inner"),
            }),
                (this.config = $.extend(
                    {
                        close: ".js-modal-close",
                        open: ".js-modal-open-" + e,
                        openClass: "modal--is-active",
                        closingClass: "modal--is-closing",
                        bodyOpenClass: "modal-open",
                        bodyOpenSolidClass: "modal-open--solid",
                        bodyClosingClass: "modal-closing",
                        closeOffContentClick: !0,
                    },
                    n,
                )),
                (this.modalIsOpen = !1),
                (this.$focusOnOpen = this.config.focusOnOpen
                    ? $(this.config.focusOnOpen)
                    : this.$modal),
                (this.isSolid = this.config.solid),
                this.init();
        }
        return (
            (t.prototype.init = function () {
                $(this.config.open).attr("aria-expanded", "false"),
                    $(this.config.open).on("click", this.open.bind(this)),
                    this.$modal
                        .find(this.config.close)
                        .on("click", this.close.bind(this)),
                    $("body").on(
                        "drawerOpen",
                        function () {
                            this.close();
                        }.bind(this),
                    );
            }),
            (t.prototype.open = function (t) {
                var e = !1;
                !this.modalIsOpen &&
                    (t ? t.preventDefault() : (e = !0),
                        t &&
                        t.stopPropagation &&
                        (t.stopPropagation(),
                            (this.$activeSource = $(t.currentTarget))),
                        this.modalIsOpen && !e && this.close(),
                        this.$modal
                            .prepareTransition()
                            .addClass(this.config.openClass),
                        this.nodes.$parent.addClass(this.config.bodyOpenClass),
                        this.isSolid &&
                        this.nodes.$parent.addClass(
                            this.config.bodyOpenSolidClass,
                        ),
                        (this.modalIsOpen = !0),
                        slate.a11y.trapFocus({
                            $container: this.$modal,
                            $elementToFocus: this.$focusOnOpen,
                            namespace: "modal_focus",
                        }),
                        this.$activeSource &&
                        this.$activeSource.attr("aria-expanded") &&
                        this.$activeSource.attr("aria-expanded", "true"),
                        $("body").trigger("modalOpen." + this.id),
                        this.bindEvents());
            }),
            (t.prototype.close = function () {
                if (this.modalIsOpen) {
                    $(document.activeElement).trigger("blur"),
                        this.$modal
                            .prepareTransition()
                            .removeClass(this.config.openClass)
                            .addClass(this.config.closingClass),
                        this.nodes.$parent.removeClass(
                            this.config.bodyOpenClass,
                        ),
                        this.nodes.$parent.addClass(
                            this.config.bodyClosingClass,
                        );
                    var t = this;
                    window.setTimeout(function () {
                        t.nodes.$parent.removeClass(t.config.bodyClosingClass),
                            t.$modal.removeClass(t.config.closingClass);
                    }, 500),
                        this.isSolid &&
                        this.nodes.$parent.removeClass(
                            this.config.bodyOpenSolidClass,
                        ),
                        (this.modalIsOpen = !1),
                        slate.a11y.removeTrapFocus({
                            $container: this.$modal,
                            namespace: "modal_focus",
                        }),
                        this.$activeSource &&
                        this.$activeSource.attr("aria-expanded") &&
                        this.$activeSource
                            .attr("aria-expanded", "false")
                            .focus(),
                        $("body").trigger("modalClose." + this.id),
                        this.unbindEvents();
                }
            }),
            (t.prototype.bindEvents = function () {
                this.nodes.$parent.on(
                    "keyup.modal",
                    function (t) {
                        27 === t.keyCode && this.close();
                    }.bind(this),
                ),
                    this.config.closeOffContentClick &&
                    (this.$modal.on("click.modal", this.close.bind(this)),
                        this.nodes.$modalContent.on(
                            "click.modal",
                            function (t) {
                                t.stopImmediatePropagation();
                            },
                        ));
            }),
            (t.prototype.unbindEvents = function () {
                this.nodes.$parent.off(".modal"),
                    this.config.closeOffContentClick &&
                    (this.$modal.off(".modal"),
                        this.nodes.$modalContent.off(".modal"));
            }),
            t
        );
    })()),
    (theme.ShopSwitch = (function () {
        function t(t) {
            var e = (this.$container = $(t)),
                n = e.attr("data-section-id");
            if (((this.cookieName = "shopswitch-" + n), e.length)) {
                this.data = {
                    countries: JSON.parse(e.data("countries")),
                    secondsBeforeShow: e.data("delay-seconds"),
                    daysBeforeReappear: e.data("delay-days"),
                    cookie: $.cookie(this.cookieName),
                    testMode: e.data("test-mode"),
                    switcherEnable: e.data("switcher-enable"),
                    switcherTemplate: e.data("switcher-template"),
                    socialReferrer:
                        document.referrer.includes("facebook.com/") ||
                        document.referrer.includes("instagram.com/") ||
                        document.referrer.includes("snapppt.com/"),
                };
                var i = _.find(this.data.countries, function (t) {
                    return t.current;
                });
                if (
                    ((this.modal = new theme.Modals(
                        "ShopSwitch-" + n,
                        "storeswitcher-popup-modal",
                    )),
                        (!this.data.cookie || this.data.socialReferrer) &&
                        $.getJSON(
                            "https://api.ipstack.com/check?access_key=f09902942cda275981fd3889ef02dfd6",
                            function (t) {
                                this.handleLocation(t.country_code);
                            }.bind(this),
                        ).fail(function (t, e, n) {
                            console.warn("ipstack request failed: " + e);
                        }),
                        $("body").on(
                            "modalClose." + e.attr("id"),
                            this.closePopup.bind(this),
                        ),
                        this.data.switcherEnable)
                ) {
                    var a = {
                        currentTitle: i.title,
                        currentImg: i.img,
                        currentCurrency: i.currency,
                        countries: _.sortBy(this.data.countries, [
                            function (t) {
                                return !t.current;
                            },
                        ]),
                    },
                        s = Mustache.render(this.data.switcherTemplate, a);
                    $(".shop-switch__dropdown").each(function () {
                        $(this).html(s);
                    });
                }
                window.ShopSwitch = this;
            }
        }
        return (
            (t.prototype = $.extend({}, t.prototype, {
                handleLocation: function (t) {
                    if (_.isUndefined(t)) {
                        console.warn("Could not get location based on IP.");
                        return;
                    }
                    var e = t,
                        n = _.findIndex(this.data.countries, function (t) {
                            return t.country_code == e;
                        }),
                        i = _.findIndex(this.data.countries, function (t) {
                            return t.default;
                        }),
                        a = _.findIndex(this.data.countries, function (t) {
                            return t.current;
                        });
                    if (n >= 0 && a == n);
                    else if (n < 0 && a == i);
                    else {
                        if (n >= 0) var s = n;
                        else var s = i;
                        console.info("Designated shop:"),
                            console.info(this.data.countries[s].url),
                            $("#" + this.data.countries[s].id).show(),
                            this.initPopupDelay();
                    }
                },
                initPopupDelay: function () {
                    (!this.data.cookie ||
                        this.data.testMode ||
                        this.data.socialReferrer) &&
                        setTimeout(
                            function () {
                                this.modal.open();
                            }.bind(this),
                            1e3 * this.data.secondsBeforeShow,
                        );
                },
                closePopup: function () {
                    if (this.data.testMode) {
                        $.removeCookie(this.cookieName, { path: "/" });
                        return;
                    }
                    $.cookie(this.cookieName, "opened", {
                        path: "/",
                        expires: this.data.daysBeforeReappear,
                    });
                },
                onLoad: function () {
                    this.modal.open();
                },
                onSelect: function () {
                    this.modal.open();
                },
                onDeselect: function () {
                    this.modal.close();
                },
                onBlockSelect: function (t) {
                    $(t.target).show();
                },
                onBlockDeselect: function (t) {
                    $(t.target).hide();
                },
                onUnload: function () { },
            })),
            t
        );
    })()),
    (theme.StoreLocator = function (t) {
        var e = {
            filterOnlineEl: $("#filter-online"),
            filterPhysicalEl: $("#filter-physical"),
            filterTextEl: $("#filterInput"),
            filterWrapEl: $(".stores__filter-wrap"),
            filterAddressEl: $("#addressInput"),
            filterRadiusEl: $("#filterRadius"),
            filterLocationEl: $("#filterLocation"),
            filterNoResultsEl: $("#filterNoResults"),
            filterInvalidAddressEl: $("#filterInvalidAddress"),
            storeEls: $(".store-item"),
            resultCountEl: $(".stores__result-count"),
            resultCountSingle: $(".stores__result-count").data("single"),
            resultCountPlural: $(".stores__result-count").data("plural"),
            storeGridClass: ".store-grid",
            storeCountryClass: ".stores__country",
            brandStoresClass: ".stores__brand-stores",
            brandStoreClass: ".brand-store",
            sectionByCountry: t.sectionByCountry,
            mapId: "storesMap",
            mapWrapClass: ".stores__map",
        },
            n = [];
        function i(i) {
            $(e.storeGridClass).empty(), $(e.storeCountryClass).hide();
            var a,
                s,
                r,
                c,
                d,
                u,
                h,
                p,
                f,
                m = e.filterOnlineEl.is(":checked"),
                g = e.filterPhysicalEl.is(":checked"),
                y = e.filterTextEl.val(),
                v = i || n;
            (filteredArray =
                ((a = v),
                    (s = y),
                    (r = m),
                    (c = g),
                    (h =
                        ((d = a),
                            (u = s),
                            (u = (u = u || "").toLowerCase().split(" ")),
                            d.filter(function (t) {
                                return u.every(function (e) {
                                    return t._search.indexOf(e) > -1;
                                });
                            }))),
                    (p = r),
                    p == (f = c)
                        ? h
                        : h.filter(function (t) {
                            return (t.online && p) || (t.physical && f);
                        }))),
                $(e.storeGridClass).toggleClass(
                    "filtered",
                    filteredArray.length != v.length,
                ),
                l(filteredArray),
                t.enableMap && o(filteredArray.length ? filteredArray : v);
        }
        function a(e) {
            var n = [];
            return _.isUndefined(e)
                ? ""
                : (e[t.csvFieldAddress] && n.push(e[t.csvFieldAddress]),
                    e[t.csvFieldPostalCode] && n.push(e[t.csvFieldPostalCode]),
                    e[t.csvFieldCity] && n.push(e[t.csvFieldCity]),
                    e[t.csvFieldRegion] && n.push(e[t.csvFieldRegion]),
                    n.join(" "));
        }
        function s(e) {
            var n = t.storeTemplate;
            return Mustache.parse(n), Mustache.to_html(n, e);
        }
        function o(i = n) {
            var a = new google.maps.LatLngBounds(),
                s = { mapTypeId: "roadmap" },
                o = [],
                r = [];
            t.mapStylesJSON && (s.styles = t.mapStylesJSON),
                t.enableUI || (s.disableDefaultUI = !0);
            var l = new google.maps.Map(document.getElementById(e.mapId), s);
            l.setTilt(45),
                i.forEach(function (t) {
                    "" != t.lat &&
                        "" != t.lat &&
                        (o.push([t.title, t.lat, t.lng]),
                            r.push([
                                '<div class="infoWindow"><h3>' +
                                t.title +
                                "</h3><p>" +
                                t.addressString +
                                "</p></div>",
                            ]));
                });
            var l,
                c,
                d,
                u = new google.maps.InfoWindow();
            for (d = 0; d < o.length; d++) {
                var h = new google.maps.LatLng(o[d][1], o[d][2]);
                if (
                    (a.extend(h),
                        (c = new google.maps.Marker({
                            position: h,
                            map: l,
                            title: o[d][0],
                            icon: t.mapMarkerImage,
                        })),
                        google.maps.event.addListener(
                            c,
                            "click",
                            (function (t, e) {
                                return function () {
                                    u.setContent(r[e][0]), u.open(l, t);
                                };
                            })(c, d),
                        ),
                        i.length > 1)
                )
                    l.fitBounds(a);
                else {
                    var p = new google.maps.LatLng(i[0].lat, i[0].lng);
                    l.setCenter(p), l.setZoom(15);
                }
            }
        }
        function r(i, a) {
            new google.maps.Geocoder();
            var s,
                r,
                c,
                d,
                u = $(e.filterAddressEl)
                    .val()
                    .replace(/[^a-z0-9\s]/gi, ""),
                h = parseInt($(e.filterRadiusEl).val(), 10);
            if ("" == u && void 0 === i && void 0 === a) {
                t.enableMap && o(n), l(n);
                return;
            }
            function p(i, a) {
                var s = new google.maps.LatLng(i, a),
                    r = n.filter(function t(e) {
                        var n,
                            i = new google.maps.LatLng(e.lat, e.lng);
                        return (
                            (n =
                                google.maps.geometry.spherical.computeDistanceBetween(
                                    i,
                                    s,
                                )),
                            0.001 * n <= h
                        );
                    });
                r.length > 0
                    ? ($(e.filterNoResultsEl).hide(), t.enableMap && o(r), l(r))
                    : ($(e.filterNoResultsEl).show(),
                        console.warn("nothing found!"));
            }
            void 0 !== i && void 0 !== a && h
                ? p(i, a)
                : u &&
                h &&
                (d =
                    ((s = u),
                        (r = s.split(" ").join("+")),
                        (c = t.gmapsAPI),
                        void $.get(
                            "https://maps.googleapis.com/maps/api/geocode/json?address=" +
                            r +
                            "&key=" +
                            c,
                            function (t) {
                                if ("ZERO_RESULTS" === t.status) {
                                    $(e.filterInvalidAddressEl).show();
                                    return;
                                }
                                $(e.filterInvalidAddressEl).hide(),
                                    p(
                                        t.results[0].geometry.location.lat,
                                        t.results[0].geometry.location.lng,
                                    );
                            },
                        )));
        }
        function l(t) {
            if (
                ($(e.storeGridClass).empty(),
                    $(e.storeCountryClass).hide(),
                    1 == t.length)
            )
                var n = e.resultCountSingle;
            else var n = e.resultCountPlural;
            $(e.resultCountEl).text(t.length + " " + n),
                e.sectionByCountry
                    ? t.sort(function (t, e) {
                        var n = t.addressCountry.toLowerCase(),
                            i = e.addressCountry.toLowerCase(),
                            a = t.title.toLowerCase(),
                            s = e.title.toLowerCase();
                        return n < i
                            ? -1
                            : n > i
                                ? 1
                                : a < s
                                    ? -1
                                    : a > s
                                        ? 1
                                        : 0;
                    })
                    : t.sort(function (t, e) {
                        var n = t.title.toUpperCase(),
                            i = e.title.toUpperCase();
                        return n < i ? -1 : n > i ? 1 : 0;
                    });
            for (var i = "", a = 0; a < t.length; a++) {
                var o = t[a];
                i = o.addressCountry;
                var r = s(o);
                e.sectionByCountry
                    ? "" != i &&
                    ($("[data-country=" + i + "]").show(),
                        $("[data-country=" + i + "] " + e.storeGridClass).append(
                            r,
                        ))
                    : $(e.storeGridClass).append(r),
                    (i = o.addressCountry);
            }
        }
        function c(t, e, n) {
            e.setPosition(n),
                e.setContent(
                    t
                        ? "Error: The Geolocation service failed."
                        : "Error: Your browser doesn't support geolocation.",
                ),
                e.open(map);
        }
        "blocks" == t.inputType
            ? ((n = t.enableMap
                ? _.remove(t.storeJSON, function (t) {
                    return !(isNaN(t.lat) || isNaN(t.lng));
                })
                : JSON.parse(t.storeJSON)),
                i())
            : t.enableMap &&
            "" != t.csvPath &&
            Papa.parse(t.csvPath, {
                download: !0,
                quoteChar: '"',
                delimiter: ";",
                skipemptylines: !0,
                header: !0,
                complete: function (s, o) {
                    var r = _.map(s.data, function (e) {
                        var n;
                        return {
                            title: e[t.csvFieldCompany],
                            addressStreet: e[t.csvFieldAddress],
                            addressPostalCode: e[t.csvFieldPostalCode],
                            addressLocality: e[t.csvFieldCity],
                            addressRegion: e[t.csvFieldRegion],
                            addressCountry: e[t.csvFieldCountry],
                            addressString: a(e),
                            phone: e[t.csvFieldPhone],
                            email: e[t.csvFieldEmail],
                            lat: parseFloat(e[t.csvFieldLatitude]),
                            lng: parseFloat(e[t.csvFieldLongitude]),
                            url: e[t.csvFieldWebsite],
                            niceUrl:
                                ((n = e[t.csvFieldWebsite]),
                                    _.isUndefined(n)
                                        ? ""
                                        : (n
                                            .replace(/http:\/\//g, "")
                                            .replace(/https:\/\//g, ""),
                                            "")),
                            _search: a(e),
                        };
                    }),
                        l = _.filter(r, function (t) {
                            return !_.isUndefined(t.addressCountry);
                        });
                    (n = l),
                        t.enableAutoFilterLocation
                            ? $(e.filterLocationEl).click()
                            : i(l);
                },
            }),
            $(e.brandStoreClass).length,
            $("#filterSearch").on("click", function (n) {
                t.enableMap || t.enableFilterLocation
                    ? ($(e.filterLocationEl).data("lat", void 0),
                        $(e.filterLocationEl).data("lng", void 0),
                        $(e.filterLocationEl).attr("data-location", !1),
                        n.preventDefault(),
                        r())
                    : (n.preventDefault(), i());
            }),
            $(e.filterRadiusEl).on("change", function (t) {
                "" != $(e.filterLocationEl).data("lat")
                    ? r(
                        $(e.filterLocationEl).data("lat"),
                        $(e.filterLocationEl).data("lng"),
                    )
                    : r();
            }),
            $(e.filterLocationEl).on("click", function (t) {
                if (
                    (t.preventDefault(),
                        "true" == $(t.target).attr("data-location"))
                ) {
                    $(t.target).attr("data-location", !1),
                        $(e.filterLocationEl).data("lat", ""),
                        $(e.filterLocationEl).data("lng", ""),
                        r();
                    return;
                }
                $(e.filterAddressEl).prop("disabled", !0),
                    $(e.filterWrapEl).addClass("loading_location"),
                    navigator.geolocation
                        ? navigator.geolocation.getCurrentPosition(
                            function (n) {
                                $(e.filterAddressEl).val(null),
                                    r(
                                        n.coords.latitude,
                                        n.coords.longitude,
                                    ),
                                    $(t.target).data(
                                        "lat",
                                        n.coords.latitude,
                                    ),
                                    $(t.target).data(
                                        "lng",
                                        n.coords.longitude,
                                    ),
                                    $(e.filterAddressEl).prop(
                                        "disabled",
                                        !1,
                                    ),
                                    $(t.target).attr("data-location", !0),
                                    $(e.filterWrapEl).removeClass(
                                        "loading_location",
                                    );
                            },
                            function () {
                                $(e.filterAddressEl).prop("disabled", !1),
                                    $(t.target).attr("data-location", !1),
                                    $(e.filterWrapEl).removeClass(
                                        "loading_location",
                                    ),
                                    c(!0, infoWindow, map.getCenter());
                            },
                        )
                        : c(!1, infoWindow, map.getCenter());
            }),
            $(e.filterTextEl).on("change", function (t) {
                i();
            });
    }),
    (theme.LifestyleGallery = (function () {
        function t(t) {
            var e = (this.$container = $(t));
            e.attr("data-section-id"),
                e.length &&
                ((this.data = {
                    carouselElement: $(e).find(
                        ".LifestyleGallery__Carousel",
                    )[0],
                }),
                    void 0 != this.data.carouselElement &&
                    (this.carousel = new theme.Carousels(
                        this.data.carouselElement,
                    )),
                    setTimeout(
                        function () {
                            this.carousel.resize();
                        }.bind(this),
                        800,
                    ),
                    setTimeout(
                        function () {
                            this.carousel.resize();
                        }.bind(this),
                        3e3,
                    ));
        }
        return (t.prototype = $.extend({}, t.prototype, {})), t;
    })()),
    (theme.Quantity = (function () {
        function t(t) {
            var e = (this.$container = $(t)),
                n = e.attr("data-section-id");
            e.length &&
                ((this.elements = {
                    modal: e.find(".modal__inner"),
                    modalInner: e.find(".quantity-popup__inner"),
                    modalInnerContent: e.find(".quantity-popup__innerContent"),
                    modalInnerTemplate: $("#quantityPopupTemplate").html(),
                    modalInnerWrap: e.find(".modal__centered"),
                    modalImage: e.find(".modal__image"),
                    headerCartDot: $(".Header__CartDot"),
                    countEl: void 0,
                    cartCountEl: $(".Header__CartCount"),
                }),
                    (this.data = { currentVariant: {} }),
                    (this.modal = new theme.Modals(n, "quantity-popup")),
                    $('[data-action="choose-quantity"]').on(
                        "click",
                        function (t) {
                            t.preventDefault(),
                                (this.elements.countEl =
                                    t.target.parentElement.parentElement.parentElement.querySelector(
                                        ".quick-add__count",
                                    ));
                            let e = $(t.currentTarget);
                            this.data.currentVariant = {
                                id: e.data("variant"),
                                title: e.data("title"),
                                max: e.data("max"),
                                mode: e.data("mode"),
                                quantity: e.data("quantity") || 1,
                                link: e.data("link") || void 0,
                                image: e.data("image") || void 0,
                            };
                            let n = this.renderModal(this.data.currentVariant);
                            this.elements.modalInnerContent.html(n),
                                (this.elements.quantityForm =
                                    this.elements.modalInnerContent.find(
                                        "#quantityForm",
                                    )),
                                (this.elements.quantityValue =
                                    this.elements.modalInnerContent.find(
                                        "#quantityValue",
                                    )),
                                (this.elements.quantityPlus =
                                    this.elements.modalInnerContent.find(
                                        "#quantityPlus",
                                    )),
                                (this.elements.quantityMinus =
                                    this.elements.modalInnerContent.find(
                                        "#quantityMinus",
                                    )),
                                (this.elements.quantitySubmit =
                                    this.elements.modalInnerContent.find(
                                        "#quantitySubmit",
                                    )),
                                (this.elements.quantityCheckmark =
                                    this.elements.modalInnerContent.find(
                                        "#quantityCheckmark",
                                    )),
                                (this.elements.quantitySuccess =
                                    this.elements.modalInner.find(
                                        "#quantitySuccess",
                                    )),
                                this.elements.modal.removeClass("success"),
                                this.elements.quantitySuccess.removeClass("active"),
                                this.elements.modalInnerWrap.toggleClass(
                                    "modal--has-image",
                                    !_.isUndefined(this.data.currentVariant.image),
                                ),
                                _.isUndefined(this.data.currentVariant.image)
                                    ? this.elements.modalImage.css({
                                        "background-image": "",
                                    })
                                    : this.elements.modalImage.css({
                                        "background-image":
                                            "url(" +
                                            this.data.currentVariant.image +
                                            ")",
                                    }),
                                this.addListeners(),
                                this.openPopup();
                        }.bind(this),
                    ),
                    $("body").on("modalClose." + e.attr("id"), () =>
                        this.closePopup(),
                    ),
                    (window.Quantity = this));
        }
        return (
            (t.prototype = $.extend({}, t.prototype, {
                renderModal: function (t) {
                    return Mustache.render(this.elements.modalInnerTemplate, t);
                },
                addToCart: function (t) {
                    if (
                        (this.elements.modalInner.addClass("loading"),
                            ("add" == this.data.currentVariant.mode
                                ? Shopify.addItem
                                : Shopify.changeItem)(
                                    this.data.currentVariant.id,
                                    t,
                                    function () {
                                        i();
                                    },
                                    function (t) {
                                        t.preventDefault(), console.warn(t);
                                    },
                                ),
                            $(this.elements.countEl).is(":empty"))
                    )
                        var e = t;
                    else var e = parseInt($(this.elements.countEl).text()) + t;
                    if ($(this.elements.cartCountEl).is(":empty")) var n = t;
                    else
                        var n =
                            parseInt($(this.elements.cartCountEl).text()) + t;
                    let i = () => {
                        this.elements.headerCartDot.addClass("is-visible"),
                            this.elements.modal.addClass("success"),
                            this.elements.quantitySuccess.addClass("active"),
                            this.elements.modalInner.removeClass("loading"),
                            $(this.elements.countEl).addClass("count-show"),
                            $(this.elements.countEl).addClass("count-added"),
                            $(this.elements.countEl).text(e),
                            $(this.elements.cartCountEl).addClass("count-show"),
                            $(this.elements.cartCountEl).addClass(
                                "count-added",
                            ),
                            $(this.elements.cartCountEl).text(n),
                            setTimeout(() => {
                                $(this.elements.countEl).removeClass(
                                    "count-added",
                                ),
                                    $(this.elements.cartCountEl).removeClass(
                                        "count-added",
                                    );
                            }, 200),
                            document.body.dispatchEvent(
                                new CustomEvent("product:added", {
                                    bubbles: !0,
                                    detail: {
                                        variant: this.data.currentVariant.id,
                                        quantity: parseInt(t),
                                    },
                                }),
                            ),
                            this.closePopup(),
                            this.elements.modal.removeClass("success"),
                            setTimeout(() => {
                                this.closePopup(),
                                    this.elements.modal.removeClass("success");
                            }, 15e3);
                    };
                },
                addListeners: function () {
                    let t =
                        parseInt(this.elements.quantityValue.attr("max")) ||
                        1e3;
                    this.elements.quantityPlus.click((e) => {
                        let n =
                            parseInt(this.elements.quantityValue.val()) + 1 ||
                            1;
                        this.elements.quantityValue.val(Math.min(t, n));
                    }),
                        this.elements.quantityMinus.click((t) => {
                            let e =
                                parseInt(this.elements.quantityValue.val()) -
                                1 || 1;
                            this.elements.quantityValue.val(Math.max(1, e));
                        }),
                        this.elements.quantityValue.change((e) => {
                            let n =
                                parseInt(this.elements.quantityValue.val()) ||
                                1;
                            this.elements.quantityValue.val(
                                Math.min(t, Math.max(1, n)),
                            );
                        }),
                        this.elements.quantityForm.submit((t) => {
                            t.preventDefault();
                            let e = parseInt(this.elements.quantityValue.val());
                            this.elements.quantityPlus.attr("disabled", !0),
                                this.elements.quantityMinus.attr(
                                    "disabled",
                                    !0,
                                ),
                                this.elements.quantityValue.attr(
                                    "disabled",
                                    !0,
                                ),
                                this.elements.quantitySubmit.attr(
                                    "disabled",
                                    !0,
                                ),
                                this.addToCart(e);
                        });
                },
                removeListeners: function () {
                    (this.elements.quantityPlus = void 0),
                        (this.elements.quantityMinus = void 0),
                        (this.elements.quantityValue = void 0),
                        (this.elements.quantityForm = void 0),
                        (this.elements.quantitySubmit = void 0);
                },
                openPopup: function () {
                    this.modal.open();
                },
                closePopup: function () {
                    if (
                        (this.elements.modal.removeClass("success"),
                            (this.data.currentVariant = {}),
                            this.removeListeners(),
                            this.modal.close(),
                            this.data.testMode)
                    ) {
                        $.removeCookie(this.cookieName, { path: "/" });
                        return;
                    }
                    this.setCookie();
                },
                setCookie: function () {
                    $.cookie(this.cookieName, !0, {
                        path: "/",
                        expires: this.data.daysBeforeReappear,
                    });
                },
                onLoad: function () {
                    this.openPopup();
                },
                onSelect: function () {
                    this.openPopup();
                },
                onDeselect: function () {
                    this.modal.close();
                },
                onBlockSelect: function (t) {
                    this.modal.modalIsOpen || this.openPopup(),
                        $(t.target).show();
                },
                onBlockDeselect: function (t) {
                    $(t.target).hide();
                },
                onUnload: function () { },
            })),
            t
        );
    })()),
    (theme.cart = function () {
        var t = { agreementCheckbox: "#cartAgreementCheckbox" };
        $("body").on("click", ".cart-recap button", function (e) {
            if (
                (e.preventDefault(),
                    console.log(t.agreementCheckbox),
                    !$(t.agreementCheckbox).is(":checked"))
            )
                return alert(window.languages.cartAgreeAlert), !1;
            $(this).submit();
        });
    }),
    $(document).ready(function () {
        var t = new slate.Sections();
        t.register("shop-switch", theme.ShopSwitch),
            t.register("lifestyle-gallery", theme.LifestyleGallery),
            t.register("quantity-popup", theme.Quantity);
        var e = { agreementCheckbox: "#cartAgreementCheckbox" };
        $("body").on("click", ".cart-recap button", function (t) {
            if (
                (console.log(e.agreementCheckbox),
                    !$(e.agreementCheckbox).is(":checked"))
            )
                return alert(window.languages.cartAgreeAlert), !1;
            $(this).submit();
        }),
            $("#ReadMoreLink").click(function () {
                $("#Productabs--MoreInfo .Collapsible__Button").attr(
                    "aria-expanded",
                    "true",
                ),
                    $("#Productabs--MoreInfo .Collapsible__Inner").css(
                        "height",
                        "auto",
                    );
            }),
            jQuery("#cart-drawer header button").click(function (t) {
                $("body").trigger("click");
            }),
            jQuery(".header-sidebar__collapsible-panel  summary").click(
                function () {
                    console.log("click"),
                        $(
                            ".header-sidebar__collapsible-panel details",
                        ).removeAttr("open"),
                        $(this).parent("details").attr("open", "");
                },
            );
    }),
    $(document).ready(function () {
        Shopify.getCart(function (t) {
            if (t.items.length > 0)
                for (var e = 0; e < t.items.length; e++)
                    $(
                        ".quick-add__wrapper[data-variant=" +
                        t.items[e].id +
                        "] .quick-add__count",
                    )
                        .text(t.items[e].quantity)
                        .addClass("count-show");
        });
    });
class Free_shipping_string {
    constructor(t) {
        (this.main = t),
            (this.settings = JSON.parse(
                t.getAttribute("data-update-free-shipping"),
            )),
            this.Init();
    }
    Init() {
        document.addEventListener("product:added", () => {
            fetch("/cart.js", {
                credentials: "same-origin",
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                },
            }).then((t) => {
                t.json().then((t) => {
                    this.ChangeText({ cartObj: t });
                });
            });
        }),
            document.addEventListener("cart:updated", (t) => {
                this.ChangeText({ cartObj: t.detail });
            });
    }
    ChangeText({ cartObj: t }) {
        if (t.total_price >= this.settings.threshold) {
            this.main.innerText = this.settings.titleAfter;
        } else {
            const priceLeft = ((this.settings.threshold - t.total_price) / 100).toFixed(2);
            this.main.innerHTML = this.settings.title.replace(
                "[price]",
                `<span class="money">${priceLeft}</span>`
            );
        }
    }
}
const free_Shipping_strings = document.querySelectorAll(
    "[data-update-free-shipping]",
);
free_Shipping_strings.forEach((t) => {
    new Free_shipping_string(t);
});
